import { buildBonusSheetHref } from '@/features/bonus/lib/bonusSheetSearch'
import type { AppRouter } from '@/shared/hooks/useAppRouter.types'

import { getQrNavigationPath } from './getQrNavigationPath'
import type { QrResolution } from './resolveQrCode'

type NavigateFromQrResolutionArgs = {
  resolution: QrResolution
  pathname: string
  router: AppRouter
  navigateTo: (path: string) => void
}

export const isBonusResolution = (resourceType: string) =>
  resourceType === 'Bonus' || resourceType === 'BonusPartner'

const getBonusPartnerId = (resource: Record<string, unknown>) => {
  const partnerId = resource?.partner_id

  if (typeof partnerId === 'number') return partnerId
  if (typeof partnerId === 'string' && partnerId) return Number(partnerId)

  return undefined
}

export const navigateFromQrResolution = ({
  resolution,
  pathname,
  router,
  navigateTo
}: NavigateFromQrResolutionArgs) => {
  if (resolution.status === 'resolved' && isBonusResolution(resolution.resourceType)) {
    const uid = resolution.resource?.uid

    if (typeof uid === 'string' && uid) {
      router.push(
        buildBonusSheetHref(pathname, uid, getBonusPartnerId(resolution.resource))
      )
      return
    }
  }

  if (
    resolution.status === 'unavailable' &&
    isBonusResolution(resolution.resourceType) &&
    resolution.resource?.unavailable_reason === 'limit_reached'
  ) {
    const uid = resolution.resource?.uid

    if (typeof uid === 'string' && uid) {
      router.push(
        buildBonusSheetHref(pathname, uid, getBonusPartnerId(resolution.resource))
      )
    }

    return
  }

  if (resolution.status === 'unavailable' && isBonusResolution(resolution.resourceType)) {
    return
  }

  navigateTo(getQrNavigationPath(resolution))
}
